import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StorePaymentMethods = (_param)=> {
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-payment-methods-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-payment-methods-stores-v2__items"
    }, items.map(({ name , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-payment-methods-stores-v2__item"
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-payment-methods-stores-v2__icon",
            alt: name,
            src: iconUrl
        }), name)
    )));
};
var StorePaymentMethods$1 = StorePaymentMethods;

export { StorePaymentMethods$1 as default };
//# sourceMappingURL=StorePaymentMethods.js.map
